import { StylesConfig } from 'react-select/src/styles'
import { theme } from '../../../theme'

export const customStyles = (
  isSmallReservation,
  error = false,
  menuMaxHeight = undefined,
  defaultOpen = false,
  menuMaxWidth = undefined,
  size = 1,
  zIndex = undefined,
  warning = false,
): StylesConfig => ({
  control: (base, state) => ({
    ...base,
    '&:hover': {
      border: error
        ? `1px solid ${theme.colors.palette.reddish}`
        : warning
        ? `1px solid ${theme.colors.palette.tangerine}`
        : state.isFocused
        ? `1px solid ${theme.colors.palette.emerald}`
        : `1px solid ${theme.colors.palette.lightGrey}`,
    },
    border: error
      ? `1px solid ${theme.colors.palette.reddish}`
      : warning
      ? `1px solid ${theme.colors.palette.tangerine}`
      : state.isFocused
      ? `1px solid ${theme.colors.palette.emerald}`
      : `1px solid ${theme.colors.palette.lightGrey}`,
    borderRadius: '4px',
    boxShadow: 'none',
    cursor: 'pointer',
    fontFamily: 'Montserrat sans-serif',
    fontSize: `${13 * size}px !important`,
    height: isSmallReservation ? `${38 * size}px` : `${42 * size}px`,
    minHeight: isSmallReservation ? `${38 * size}px` : `${42 * size}px`,
    outline: 'none',
  }),
  dropdownIndicator: base => ({
    display: base.display,
    pointerEvents: 'none',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  input: base => ({
    ...base,
    width: '20px !important',
  }),
  menu: base => ({
    ...base,
    position: defaultOpen ? 'unset' : base.position,
    zIndex: zIndex ? zIndex : base.zIndex,
  }),
  menuList: base => ({
    ...base,
    maxHeight: menuMaxHeight ? menuMaxHeight : base.maxHeight,
    maxWidth: menuMaxWidth ? menuMaxWidth : base.maxWidth,
    wordWrap: 'break-word',
  }),
  menuPortal: base => ({
    ...base,
    zIndex: zIndex ? zIndex : base.zIndex,
  }),
  noOptionsMessage: base => {
    return {
      ...base,
      fontSize: `${16 * size}px`,
      padding: `${8 * size}px ${12 * size}px`,
    }
  },
  option: (base, { isSelected }) => ({
    ...base,
    '&:hover': {
      backgroundColor: theme.colors.palette.greyTwo,
    },
    backgroundColor: isSelected ? theme.colors.palette.greyTwo : 'white',
    color: 'black',
    fontSize: `${16 * size}px`,
    lineHeight: `${16 * size}px`,
    minHeight: isSmallReservation ? `${38 * size}px` : `${42 * size}px`,
    overflow: 'hidden',
    padding: `${8 * size}px ${12 * size}px`,
  }),
  valueContainer: base => ({
    ...base,
    display: 'inline-block',
    overflowX: 'hidden',
  }),
})
